import React from "react";

const MAP = {
  pending_grn: { label: "PENDING GRN", cls: "bg-[#E65100]/10 text-[#E65100] border-[#E65100]/30" },
  grn_created: { label: "GRN CREATED", cls: "bg-[#1565C0]/10 text-[#1565C0] border-[#1565C0]/30" },
  pending_checker: { label: "PENDING CHECKER", cls: "bg-[#E65100]/10 text-[#E65100] border-[#E65100]/30" },
  approved: { label: "APPROVED", cls: "bg-[#2E7D32]/10 text-[#2E7D32] border-[#2E7D32]/30" },
  sent_back: { label: "SENT BACK", cls: "bg-[#C62828]/10 text-[#C62828] border-[#C62828]/30" },
  quality_pending: { label: "QUALITY PENDING", cls: "bg-[#E65100]/10 text-[#E65100] border-[#E65100]/30" },
  quality_approved: { label: "QUALITY OK", cls: "bg-[#2E7D32]/10 text-[#2E7D32] border-[#2E7D32]/30" },
  quality_rejected: { label: "QUALITY NG", cls: "bg-[#C62828]/10 text-[#C62828] border-[#C62828]/30" },
  quality_hold: { label: "ON HOLD", cls: "bg-[#E65100]/10 text-[#E65100] border-[#E65100]/30" },
  deviation_accepted: { label: "DEVIATION ACCEPTED", cls: "bg-[#1565C0]/10 text-[#1565C0] border-[#1565C0]/30" },
  conditional: { label: "CONDITIONAL", cls: "bg-[#1565C0]/10 text-[#1565C0] border-[#1565C0]/30" },
  rejected_return: { label: "RETURN TO SUPPLIER", cls: "bg-[#C62828]/10 text-[#C62828] border-[#C62828]/30" },
  stock_in: { label: "IN STOCK", cls: "bg-[#2E7D32]/10 text-[#2E7D32] border-[#2E7D32]/30" },
  in_stock: { label: "IN STOCK", cls: "bg-[#2E7D32]/10 text-[#2E7D32] border-[#2E7D32]/30" },
  consumed: { label: "CONSUMED", cls: "bg-[#0D2B5E]/10 text-[#0D2B5E] border-[#0D2B5E]/30" },
  short: { label: "SHORT", cls: "bg-[#E65100]/10 text-[#E65100] border-[#E65100]/30" },
  excess: { label: "EXCESS", cls: "bg-[#E65100]/10 text-[#E65100] border-[#E65100]/30" },
  unscheduled: { label: "UNSCHEDULED", cls: "bg-[#E65100]/10 text-[#E65100] border-[#E65100]/30" },
  ok: { label: "OK", cls: "bg-[#2E7D32]/10 text-[#2E7D32] border-[#2E7D32]/30" },
  low: { label: "LOW", cls: "bg-[#E65100]/10 text-[#E65100] border-[#E65100]/30" },
  over: { label: "OVER", cls: "bg-[#E65100]/10 text-[#E65100] border-[#E65100]/30" },
};

export default function StatusBadge({ status }) {
  const m = MAP[status] || { label: String(status || "-").toUpperCase(), cls: "bg-[#0D2B5E]/10 text-[#0D2B5E] border-[#0D2B5E]/30" };
  return (
    <span className={`inline-flex text-[10px] font-bold tracking-widest uppercase px-2 py-0.5 border ${m.cls} rounded-sm`}>
      {m.label}
    </span>
  );
}
